export default (state = null, action) => {
    switch (action.type) {
        case 'SET_MODAL_DATA':
            return action.payload
        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/scripts/reducers/modalData.js